import { getMessages } from '../../../../../../../../store/constants';

export const WEBHOOKS_SECTION_PLACEHOLDER = getMessages().getText('board_settings.webhooks.placeholder');
export const WEBHOOKS_SECTION_TEXT = getMessages().getText('board_settings.webhooks.text');
export const WEBHOOKS_SECTION_ERROR_URL = getMessages().getText('board_settings.webhooks.error.url');
export const WEBHOOKS_SECTION_ERROR_RESPONSE = getMessages().getText('board_settings.webhooks.error.response');
export const WEBHOOKS_SECTION_ERROR_STATUS = getMessages().getText('board_settings.webhooks.error.status');
